// 50mm x 250m width with 2 colors
export const fiftyMm250mOption1Color = [
  { label: "3 rolls", rolls: 3, price: 33.1, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 23.27, boxCount: 1 },
  { label: "9 rolls", rolls: 9, price: 19.99, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 18.35, boxCount: 1 },
  { label: "15 rolls", rolls: 15, price: 17.37, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 16.72, boxCount: 1 },
  { label: "21 rolls", rolls: 21, price: 16.25, boxCount: 1 },
  { label: "24 rolls", rolls: 24, price: 15.0, boxCount: 1 },
  { label: "27 rolls", rolls: 27, price: 15.62, boxCount: 1 },
  { label: "30 rolls", rolls: 30, price: 15.4, boxCount: 1 },
  { label: "33 rolls", rolls: 33, price: 15.23, boxCount: 1 },
  { label: "36 rolls", rolls: 36, price: 15.08, boxCount: 1 },
  { label: "39 rolls", rolls: 39, price: 14.95, boxCount: 1 },
  { label: "42 rolls", rolls: 42, price: 14.84, boxCount: 1 },
  { label: "45 rolls", rolls: 45, price: 14.75, boxCount: 1 },
  { label: "48 rolls", rolls: 48, price: 14.67, boxCount: 1 },
  { label: "51 rolls", rolls: 51, price: 14.59, boxCount: 1 },
  { label: "54 rolls", rolls: 54, price: 14.53, boxCount: 1 },
  { label: "57 rolls", rolls: 57, price: 14.47, boxCount: 1 },
  { label: "60 rolls", rolls: 60, price: 14.42, boxCount: 1 },
  { label: "63 rolls", rolls: 63, price: 14.37, boxCount: 1 },
  { label: "66 rolls", rolls: 66, price: 14.33, boxCount: 1 },
]

// 50mm x 250m width, 1 color option
export const fiftyMm250mOption2Color = [
  { label: "3 rolls", rolls: 3, price: 46.77, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 30.1, boxCount: 1 },
  { label: "9 rolls", rolls: 9, price: 24.55, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 21.77, boxCount: 1 },
  { label: "15 rolls", rolls: 15, price: 20.1, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 18.99, boxCount: 1 },
  { label: "21 rolls", rolls: 21, price: 18.2, boxCount: 1 },
  { label: "24 rolls", rolls: 24, price: 17.6, boxCount: 1 },
  { label: "27 rolls", rolls: 27, price: 17.14, boxCount: 1 },
  { label: "30 rolls", rolls: 30, price: 16.77, boxCount: 1 },
  { label: "33 rolls", rolls: 33, price: 16.47, boxCount: 1 },
  { label: "36 rolls", rolls: 36, price: 16.22, boxCount: 1 },
  { label: "39 rolls", rolls: 39, price: 16.0, boxCount: 1 },
  { label: "42 rolls", rolls: 42, price: 15.82, boxCount: 1 },
  { label: "45 rolls", rolls: 45, price: 15.66, boxCount: 1 },
  { label: "48 rolls", rolls: 48, price: 15.52, boxCount: 1 },
  { label: "51 rolls", rolls: 51, price: 15.4, boxCount: 1 },
  { label: "54 rolls", rolls: 54, price: 15.29, boxCount: 1 },
  { label: "57 rolls", rolls: 57, price: 15.19, boxCount: 1 },
  { label: "60 rolls", rolls: 60, price: 15.1, boxCount: 1 },
  { label: "63 rolls", rolls: 63, price: 15.02, boxCount: 1 },
  { label: "66 rolls", rolls: 66, price: 14.95, boxCount: 1 },
]

export const fiftyMm250mOption3Color = [
  { label: "3 rolls", rolls: 3, price: 61.77, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 37.6, boxCount: 1 },
  { label: "9 rolls", rolls: 9, price: 29.55, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 25.52, boxCount: 1 },
  { label: "15 rolls", rolls: 15, price: 23.1, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 21.49, boxCount: 1 },
  { label: "21 rolls", rolls: 21, price: 20.34, boxCount: 1 },
  { label: "24 rolls", rolls: 24, price: 19.48, boxCount: 1 },
  { label: "27 rolls", rolls: 27, price: 18.81, boxCount: 1 },
  { label: "30 rolls", rolls: 30, price: 18.27, boxCount: 1 },
  { label: "33 rolls", rolls: 33, price: 17.83, boxCount: 1 },
  { label: "36 rolls", rolls: 36, price: 17.47, boxCount: 1 },
  { label: "39 rolls", rolls: 39, price: 17.16, boxCount: 1 },
  { label: "42 rolls", rolls: 42, price: 16.89, boxCount: 1 },
  { label: "45 rolls", rolls: 45, price: 16.66, boxCount: 1 },
  { label: "48 rolls", rolls: 48, price: 16.46, boxCount: 1 },
  { label: "51 rolls", rolls: 51, price: 16.28, boxCount: 1 },
  { label: "54 rolls", rolls: 54, price: 16.12, boxCount: 1 },
  { label: "57 rolls", rolls: 57, price: 15.98, boxCount: 1 },
  { label: "60 rolls", rolls: 60, price: 15.85, boxCount: 1 },
  { label: "63 rolls", rolls: 63, price: 15.74, boxCount: 1 },
  { label: "66 rolls", rolls: 66, price: 15.63, boxCount: 1 },
]

//75 mm
export const seventyFiveMm250mOption1 = [
  { label: "2 rolls", rolls: 2, price: 49.66, boxCount: 1 },
  { label: "4 rolls", rolls: 4, price: 34.91, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 29.99, boxCount: 1 },
  { label: "8 rolls", rolls: 8, price: 27.53, boxCount: 1 },
  { label: "10 rolls", rolls: 10, price: 26.06, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 25.07, boxCount: 1 },
  { label: "14 rolls", rolls: 14, price: 24.37, boxCount: 1 },
  { label: "16 rolls", rolls: 16, price: 23.84, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 23.43, boxCount: 1 },
  { label: "20 rolls", rolls: 20, price: 23.11, boxCount: 1 },
  { label: "22 rolls", rolls: 22, price: 22.84, boxCount: 1 },
  { label: "24 rolls", rolls: 24, price: 22.61, boxCount: 1 },
  { label: "26 rolls", rolls: 26, price: 22.42, boxCount: 1 },
  { label: "28 rolls", rolls: 28, price: 22.26, boxCount: 1 },
  { label: "30 rolls", rolls: 30, price: 22.12, boxCount: 1 },
  { label: "32 rolls", rolls: 32, price: 22.0, boxCount: 1 },
  { label: "34 rolls", rolls: 34, price: 21.89, boxCount: 1 },
  { label: "36 rolls", rolls: 36, price: 21.8, boxCount: 1 },
  { label: "38 rolls", rolls: 38, price: 21.71, boxCount: 1 },
  { label: "40 rolls", rolls: 40, price: 21.63, boxCount: 1 },
  { label: "42 rolls", rolls: 42, price: 21.56, boxCount: 1 },
  { label: "44 rolls", rolls: 44, price: 21.5, boxCount: 1 },
]
export const seventyFiveMm250mOption2 = [
  { label: "2 rolls", rolls: 2, price: 70.16, boxCount: 1 },
  { label: "4 rolls", rolls: 4, price: 45.16, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 36.82, boxCount: 1 },
  { label: "8 rolls", rolls: 8, price: 32.66, boxCount: 1 },
  { label: "10 rolls", rolls: 10, price: 30.16, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 28.49, boxCount: 1 },
  { label: "14 rolls", rolls: 14, price: 27.3, boxCount: 1 },
  { label: "16 rolls", rolls: 16, price: 26.41, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 25.71, boxCount: 1 },
  { label: "20 rolls", rolls: 20, price: 25.16, boxCount: 1 },
  { label: "22 rolls", rolls: 22, price: 24.7, boxCount: 1 },
  { label: "24 rolls", rolls: 24, price: 24.32, boxCount: 1 },
  { label: "26 rolls", rolls: 26, price: 23.99, boxCount: 1 },
  { label: "28 rolls", rolls: 28, price: 23.73, boxCount: 1 },
  { label: "30 rolls", rolls: 30, price: 23.49, boxCount: 1 },
  { label: "32 rolls", rolls: 32, price: 23.28, boxCount: 1 },
  { label: "34 rolls", rolls: 34, price: 23.1, boxCount: 1 },
  { label: "36 rolls", rolls: 36, price: 22.93, boxCount: 1 },
  { label: "38 rolls", rolls: 38, price: 22.79, boxCount: 1 },
  { label: "40 rolls", rolls: 40, price: 22.66, boxCount: 1 },
  { label: "42 rolls", rolls: 42, price: 22.54, boxCount: 1 },
  { label: "44 rolls", rolls: 44, price: 22.43, boxCount: 1 },
]

export const seventyFiveMm250mOption3 = [
  { label: "2 rolls", rolls: 2, price: 92.66, boxCount: 1 },
  { label: "4 rolls", rolls: 4, price: 56.41, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 44.32, boxCount: 1 },
  { label: "8 rolls", rolls: 8, price: 38.28, boxCount: 1 },
  { label: "10 rolls", rolls: 10, price: 34.66, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 32.24, boxCount: 1 },
  { label: "14 rolls", rolls: 14, price: 30.51, boxCount: 1 },
  { label: "16 rolls", rolls: 16, price: 29.22, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 28.21, boxCount: 1 },
  { label: "20 rolls", rolls: 20, price: 27.41, boxCount: 1 },
  { label: "22 rolls", rolls: 22, price: 26.75, boxCount: 1 },
  { label: "24 rolls", rolls: 24, price: 26.2, boxCount: 1 },
  { label: "26 rolls", rolls: 26, price: 25.73, boxCount: 1 },
  { label: "28 rolls", rolls: 28, price: 25.33, boxCount: 1 },
  { label: "30 rolls", rolls: 30, price: 24.99, boxCount: 1 },
  { label: "32 rolls", rolls: 32, price: 24.69, boxCount: 1 },
  { label: "34 rolls", rolls: 34, price: 24.42, boxCount: 1 },
  { label: "36 rolls", rolls: 36, price: 24.18, boxCount: 1 },
  { label: "38 rolls", rolls: 38, price: 23.97, boxCount: 1 },
  { label: "40 rolls", rolls: 40, price: 23.78, boxCount: 1 },
  { label: "42 rolls", rolls: 42, price: 23.61, boxCount: 1 },
  { label: "44 rolls", rolls: 44, price: 23.45, boxCount: 1 },
]

//100 mm options
export const oneHundredMm250mOption1 = [
  { label: "2 rolls", rolls: 2, price: 69.52, boxCount: 1 },
  { label: "4 rolls", rolls: 4, price: 48.87, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 41.99, boxCount: 1 },
  { label: "8 rolls", rolls: 8, price: 38.54, boxCount: 1 },
  { label: "10 rolls", rolls: 10, price: 36.48, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 35.1, boxCount: 1 },
  { label: "14 rolls", rolls: 14, price: 34.12, boxCount: 1 },
  { label: "16 rolls", rolls: 16, price: 33.38, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 32.8, boxCount: 1 },
  { label: "20 rolls", rolls: 20, price: 32.35, boxCount: 1 },
  { label: "22 rolls", rolls: 22, price: 31.98, boxCount: 1 },
  { label: "24 rolls", rolls: 24, price: 31.65, boxCount: 1 },
  { label: "26 rolls", rolls: 26, price: 31.4, boxCount: 1 },
  { label: "28 rolls", rolls: 28, price: 31.16, boxCount: 1 },
  { label: "30 rolls", rolls: 30, price: 30.97, boxCount: 1 },
  { label: "32 rolls", rolls: 32, price: 30.8, boxCount: 1 },
  { label: "34 rolls", rolls: 34, price: 30.65, boxCount: 1 },
  { label: "36 rolls", rolls: 36, price: 30.52, boxCount: 1 },
  { label: "38 rolls", rolls: 38, price: 30.39, boxCount: 1 },
  { label: "40 rolls", rolls: 40, price: 30.28, boxCount: 1 },
  { label: "42 rolls", rolls: 42, price: 30.18, boxCount: 1 },
  { label: "44 rolls", rolls: 44, price: 30.1, boxCount: 1 },
]

export const oneHundredMm250mOption2 = [
  { label: "2 rolls", rolls: 2, price: 98.22, boxCount: 1 },
  { label: "4 rolls", rolls: 4, price: 63.22, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 51.55, boxCount: 1 },
  { label: "8 rolls", rolls: 8, price: 45.72, boxCount: 1 },
  { label: "10 rolls", rolls: 10, price: 42.22, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 39.89, boxCount: 1 },
  { label: "14 rolls", rolls: 14, price: 38.22, boxCount: 1 },
  { label: "16 rolls", rolls: 16, price: 36.97, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 35.99, boxCount: 1 },
  { label: "20 rolls", rolls: 20, price: 35.22, boxCount: 1 },
  { label: "22 rolls", rolls: 22, price: 34.58, boxCount: 1 },
  { label: "24 rolls", rolls: 24, price: 34.05, boxCount: 1 },
  { label: "26 rolls", rolls: 26, price: 33.59, boxCount: 1 },
  { label: "28 rolls", rolls: 28, price: 33.22, boxCount: 1 },
  { label: "30 rolls", rolls: 30, price: 32.89, boxCount: 1 },
  { label: "32 rolls", rolls: 32, price: 32.59, boxCount: 1 },
  { label: "34 rolls", rolls: 34, price: 32.34, boxCount: 1 },
  { label: "36 rolls", rolls: 36, price: 32.1, boxCount: 1 },
  { label: "38 rolls", rolls: 38, price: 31.91, boxCount: 1 },
  { label: "40 rolls", rolls: 40, price: 31.72, boxCount: 1 },
  { label: "42 rolls", rolls: 42, price: 31.56, boxCount: 1 },
  { label: "44 rolls", rolls: 44, price: 31.4, boxCount: 1 },
]

export const oneHundredMm250mOption3 = [
  { label: "2 rolls", rolls: 2, price: 129.72, boxCount: 1 },
  { label: "4 rolls", rolls: 4, price: 78.97, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 62.05, boxCount: 1 },
  { label: "8 rolls", rolls: 8, price: 53.59, boxCount: 1 },
  { label: "10 rolls", rolls: 10, price: 48.52, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 45.14, boxCount: 1 },
  { label: "14 rolls", rolls: 14, price: 42.72, boxCount: 1 },
  { label: "16 rolls", rolls: 16, price: 40.91, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 39.49, boxCount: 1 },
  { label: "20 rolls", rolls: 20, price: 38.37, boxCount: 1 },
  { label: "22 rolls", rolls: 22, price: 37.45, boxCount: 1 },
  { label: "24 rolls", rolls: 24, price: 36.68, boxCount: 1 },
  { label: "26 rolls", rolls: 26, price: 36.02, boxCount: 1 },
  { label: "28 rolls", rolls: 28, price: 35.46, boxCount: 1 },
  { label: "30 rolls", rolls: 30, price: 34.99, boxCount: 1 },
  { label: "32 rolls", rolls: 32, price: 34.57, boxCount: 1 },
  { label: "34 rolls", rolls: 34, price: 34.19, boxCount: 1 },
  { label: "36 rolls", rolls: 36, price: 33.85, boxCount: 1 },
  { label: "38 rolls", rolls: 38, price: 33.56, boxCount: 1 },
  { label: "40 rolls", rolls: 40, price: 33.29, boxCount: 1 },
  { label: "42 rolls", rolls: 42, price: 33.05, boxCount: 1 },
  { label: "44 rolls", rolls: 44, price: 32.83, boxCount: 1 },
]

// 150mm x 250m options (based on 75mm x 250m)
export const oneHundredFiftyMm250mOption1 = [
  { label: "2 rolls", rolls: 2, price: 69.82, boxCount: 1 },
  { label: "3 rolls", rolls: 3, price: 59.98, boxCount: 1 },
  { label: "4 rolls", rolls: 4, price: 55.06, boxCount: 1 },
  { label: "5 rolls", rolls: 5, price: 52.12, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 50.14, boxCount: 1 },
  { label: "7 rolls", rolls: 7, price: 48.74, boxCount: 1 },
  { label: "8 rolls", rolls: 8, price: 47.68, boxCount: 1 },
  { label: "9 rolls", rolls: 9, price: 46.86, boxCount: 1 },
  { label: "10 rolls", rolls: 10, price: 46.22, boxCount: 1 },
  { label: "11 rolls", rolls: 11, price: 45.68, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 45.22, boxCount: 1 },
  { label: "13 rolls", rolls: 13, price: 44.84, boxCount: 1 },
  { label: "14 rolls", rolls: 14, price: 44.52, boxCount: 1 },
  { label: "15 rolls", rolls: 15, price: 44.24, boxCount: 1 },
  { label: "16 rolls", rolls: 16, price: 44.0, boxCount: 1 },
  { label: "17 rolls", rolls: 17, price: 43.78, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 43.6, boxCount: 1 },
  { label: "19 rolls", rolls: 19, price: 43.42, boxCount: 1 },
  { label: "20 rolls", rolls: 20, price: 43.26, boxCount: 1 },
  { label: "21 rolls", rolls: 21, price: 43.12, boxCount: 1 },
  { label: "22 rolls", rolls: 22, price: 43.0, boxCount: 1 },
]

export const oneHundredFiftyMm250mOption2 = [
  { label: "2 rolls", rolls: 2, price: 90.32, boxCount: 1 },
  { label: "3 rolls", rolls: 3, price: 73.64, boxCount: 1 },
  { label: "4 rolls", rolls: 4, price: 65.32, boxCount: 1 },
  { label: "5 rolls", rolls: 5, price: 60.32, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 56.98, boxCount: 1 },
  { label: "7 rolls", rolls: 7, price: 54.6, boxCount: 1 },
  { label: "8 rolls", rolls: 8, price: 52.82, boxCount: 1 },
  { label: "9 rolls", rolls: 9, price: 51.42, boxCount: 1 },
  { label: "10 rolls", rolls: 10, price: 50.32, boxCount: 1 },
  { label: "11 rolls", rolls: 11, price: 49.4, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 48.64, boxCount: 1 },
  { label: "13 rolls", rolls: 13, price: 47.98, boxCount: 1 },
  { label: "14 rolls", rolls: 14, price: 47.46, boxCount: 1 },
  { label: "15 rolls", rolls: 15, price: 46.98, boxCount: 1 },
  { label: "16 rolls", rolls: 16, price: 46.56, boxCount: 1 },
  { label: "17 rolls", rolls: 17, price: 46.2, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 45.86, boxCount: 1 },
  { label: "19 rolls", rolls: 19, price: 45.58, boxCount: 1 },
  { label: "20 rolls", rolls: 20, price: 45.32, boxCount: 1 },
  { label: "21 rolls", rolls: 21, price: 45.08, boxCount: 1 },
  { label: "22 rolls", rolls: 22, price: 44.86, boxCount: 1 },
]

export const oneHundredFiftyMm250mOption3 = [
  { label: "2 rolls", rolls: 2, price: 112.82, boxCount: 1 },
  { label: "3 rolls", rolls: 3, price: 88.64, boxCount: 1 },
  { label: "4 rolls", rolls: 4, price: 76.56, boxCount: 1 },
  { label: "5 rolls", rolls: 5, price: 69.32, boxCount: 1 },
  { label: "6 rolls", rolls: 6, price: 64.48, boxCount: 1 },
  { label: "7 rolls", rolls: 7, price: 61.02, boxCount: 1 },
  { label: "8 rolls", rolls: 8, price: 58.44, boxCount: 1 },
  { label: "9 rolls", rolls: 9, price: 56.42, boxCount: 1 },
  { label: "10 rolls", rolls: 10, price: 54.82, boxCount: 1 },
  { label: "11 rolls", rolls: 11, price: 53.5, boxCount: 1 },
  { label: "12 rolls", rolls: 12, price: 52.4, boxCount: 1 },
  { label: "13 rolls", rolls: 13, price: 51.46, boxCount: 1 },
  { label: "14 rolls", rolls: 14, price: 50.66, boxCount: 1 },
  { label: "15 rolls", rolls: 15, price: 49.98, boxCount: 1 },
  { label: "16 rolls", rolls: 16, price: 49.38, boxCount: 1 },
  { label: "17 rolls", rolls: 17, price: 48.84, boxCount: 1 },
  { label: "18 rolls", rolls: 18, price: 48.36, boxCount: 1 },
  { label: "19 rolls", rolls: 19, price: 47.94, boxCount: 1 },
  { label: "20 rolls", rolls: 20, price: 47.56, boxCount: 1 },
  { label: "21 rolls", rolls: 21, price: 47.22, boxCount: 1 },
  { label: "22 rolls", rolls: 22, price: 46.9, boxCount: 1 },
]

export const seventyFiveTwoHundred = [
  { label: "90 rolls", rolls: 90, price: 17.04, boxCount: 1 },
  { label: "70 rolls", rolls: 70, price: 17.04, boxCount: 1 },
  { label: "20 rolls", rolls: 70, price: 23.11, boxCount: 1 },
]

//75x100 - 76 for roll options
export const seventyFiveHundred = [{ label: "20 rolls", rolls: 20, price: 8.6, boxCount: 1 }]
